import { spawn, call, all } from 'redux-saga/effects'
import { watchLogin, watchAutoLogout } from 'logic/authentication/auth.sagas'
import { watchManualLogout } from 'logic/user/user.sagas'
import { watchLoginSuccess } from 'logic/analytics/analytics.sagas'

function* rootSaga() {
    const sagas = [watchLogin, watchAutoLogout, watchManualLogout, watchLoginSuccess] // imported sagas

    // yielding sagas as spawn process will separate one logic to another
    // and prevents that one part of system breaks it all
    // but the errors must be handled per module
    // and the circuit breaker must be aware of each part is failing
    // here it will auto recover - cb must deal with it
    yield all(
        sagas.map((saga) =>
            spawn(function* () {
                while (true) {
                    try {
                        yield call(saga)
                        break
                    } catch (e) {
                        console.error(e)
                    }
                }
            })
        )
    )
}

export default rootSaga
